import styles from "styles/components/clapIcon.module.scss";

const ClapIcon = () => <span className={styles.wrapper}>👏</span>;

export default ClapIcon;
